var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal",attrs:{"size":"md"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('div',{staticClass:"d-flex h-100 align-items-center"},[_c('login-form',_vm._g({attrs:{"candidate":_vm.loginCandidate,"errors":_vm.errors}},_vm.$listeners))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }